/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_CInputs */

const cs_enum_c = /** @type {(inputs: Enum_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C`)
};

const en_enum_c = /** @type {(inputs: Enum_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C`)
};

/**
* | output |
* | --- |
* | "C" |
*
* @param {Enum_CInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_c = /** @type {((inputs?: Enum_CInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_CInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_c(inputs)
	return cs_enum_c(inputs)
});